export default errorsObj =>
  Object.values(errorsObj).reduce((prev, next) => [...prev, ...next]);
